<template>
  <List>
    <ListItem
      v-for="{ name, value, provider } in items"
      :key="value"
      component="button"
      @click="localValue = value"
    >
      <ListItemIcon>
        <InstagramIcon v-if="provider === 'instagram'" />
        <YoutubeIcon v-if="provider === 'youtube'" />
      </ListItemIcon>
      <ListItemTitle>{{ name }}</ListItemTitle>
    </ListItem>
  </List>
</template>

<script>
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemTitle,
  InstagramIcon,
  YoutubeIcon,
} from '@campsite-bio/component-lib';
import { toRefs } from 'vue';

import { useModel } from '../../compositions';

export default {
  components: {
    List,
    ListItem,
    ListItemIcon,
    ListItemTitle,
    InstagramIcon,
    YoutubeIcon,
  },

  props: {
    value: {
      type: String,
      default: null,
    },

    items: {
      type: Array,
      default: null,
    },
  },

  setup(props, { emit }) {
    const { value } = toRefs(props);
    const localValue = useModel(value, (val) => emit('input', val));

    return { localValue };
  },
};
</script>

<style lang="scss" scoped></style>
